import * as React from 'react'
import { Accordion, Button, Card, Form, Image } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import Damage from './Damage'
import Feedback from './Feedback'
import images from '../../../../constants/images'
import Infraction from './Infraction'
import InputAutoComplete from '../../../../components/InputAutoComplete'
import Invoice from './Invoice'
import { prepareWorkerInvoice } from './InvoiceUtils'

import Ratings from 'react-ratings-declarative'
import { copyObject, isNumber, randomId } from '../../../../utils'
import InputSearchUsers from '../../../../components/InputSearchUsers/InputSearchUsers'
import { DamageObj, DamageT, InfractionObj, InfractionT, InvoiceWorkerT, JobWorkerObj, JobWorkerT } from '../../../../types/JobWorker'
import * as _ from 'lodash'
import CrewPermissions from './CrewPermissions'
import { useImmer } from 'use-immer'

import InputPhone from '../../../../components/InputPhone'
import {  AxiosInstance } from '../../../../utils/RequestMethods'
import config from '../../../../constants/config'
import { IAppState } from '../../../../redux/reducers'
import { AuthStateT } from '../../../../redux/reducers/authReducer'
import { JobT } from '../../../../types/Job'
import { getInitialsLastName } from '../../../../utils/utilsT'
import { currentUserIsClient, currentUserIsManager } from '../../../../utils/currentUser'

// export const WorkerObj: JobWorkerT = {
//     id: null,
//     address: '',
//     address2: '',
//     addressDetails: {
//         "address": "",
//         "latitude": "",
//         "longitude": "",
//         "country": "",
//         "state": "",
//         "city": "",
//         "address_line_one": "",
//         "address_line_two": "",
//         "zipcode": "",
//     },
//     billingContact: true,
//     damages: [DamageObj],
//     email: '',
//     firstName: '',
//     infractions: [InfractionObj],
//     invoice: [],
//     lastName: '',
//     phone: '',
//     profilePic: '',
//     rating: 2.5,     // Out of 5.0
//     status: '',
//     hourlyRate: 12,
//     isCompany: false,
//     jobs: [],
//     notes: '',
//     permissions: [],
//     noShow: false,
//     isDirty: false,
// }

interface WorkerProps {
    // crew: any   // TODO Convert to Array<WorkerT>
    job: JobT
    index: number
    onChangeAccordion?(index: number): void,
    removeWorker(index: number): void
    updateCrew(workerIndex: number, worker: JobWorkerT): void
    updateJob(key: string, value: any): void
    worker: JobWorkerT
    jobDuration: number
}


const Worker: React.FunctionComponent<WorkerProps> = ({ index, removeWorker, updateCrew, updateJob, worker, jobDuration, job }): JSX.Element => {
    let auth: AuthStateT = useSelector((state: IAppState) => state.auth)
    const isClient = currentUserIsClient()
    const isManager = currentUserIsManager()
    // let roles = auth.userData && auth.userData.roles
    const [workerDirty, setWorkerDirty] = React.useState(copyObject(JobWorkerObj))
    const [isReady, setIsReady] = React.useState(false)
    const [workerOrigin, setWorkerOrigin] = React.useState(null)
    const [hourlyRate, setHourlyRate] = React.useState(0);
    const isLaborFlat = job.companyInfo && job.companyInfo.defaultWorkerPay == "laborFlat"


    React.useEffect(() => {

        if (!_.isEqual(worker, workerDirty)) {

            setWorkerDirty(worker)
            setHourlyRate(worker.hourlyRate)
        }
        // if (!_.isEqual(worker, workerOrigin) && worker.id != 0) {
        //     refreshWorker(worker.id)
        // }
        setIsReady(true)
    }, [worker]);


    /**
     *
     * @param workerId
     */
    const refreshWorker = async (workerId: number) => {
        if (workerId == null || workerId == undefined) {
            return null;
        }
        AxiosInstance.get(`${config.url.users}/${workerId}`).then((res) => {
            if (res && res.data) {
                const cloneWorker = { ...copyObject(worker), ...res.data }
                setWorkerOrigin(cloneWorker)
                setHourlyRate(cloneWorker.hourlyRate)
            }
        })
    }

    const addDamage = (): void => {
        let workerClone = copyObject(worker)
        workerClone.damages.push(copyObject(DamageObj))
        setWorkerDirty(workerClone)
        updateCrew(index, workerClone)
    }

    const addInfraction = (): void => {
        let workerClone = copyObject(worker)
        workerClone.infractions.push(copyObject(InfractionObj))
        setWorkerDirty(workerClone)
        updateCrew(index, workerClone)
    }



    /**
     *
     * @param worker
     */

    const onChangeWorker = (worker: JobWorkerT) => {
        let cloneWorker = copyObject(worker)
        const invoiceArr = _.has(cloneWorker, 'invoice') && _.isArray(cloneWorker.invoice) ? cloneWorker.invoice : []
        let invoice = prepareWorkerInvoice(invoiceArr, worker.hourlyRate, jobDuration)
        cloneWorker.invoice = copyObject(invoice)
        setWorkerDirty(cloneWorker)
        updateCrew(index, cloneWorker)

    }

    const adminManagerRenderWorker = (): JSX.Element => {
        const checkBoxUniqueId = randomId();
        return (

            <div key={index}>
                <div style={{ display: 'grid', gridTemplateColumns: 'minmax(100px, 120px) 1fr' }}>
                    <span>
                        <Image src={(workerDirty.profilePic == null || workerDirty.profilePic == '') ? images.noProfilePic : workerDirty.profilePic} height={100} width={100} />
                    </span>
                    <span>
                        <InputSearchUsers
                            style={{ height: "3rem", fontSize: "2em" }}
                            query={{
                                roles: ['administrator', 'worker', 'manager']
                            }}
                            textValue={`${workerDirty.firstName != '' || workerDirty.lastName != '' ? `${workerDirty.firstName} ${workerDirty.lastName}` : ''}`}
                            onSelectUser={(user) => {
                                //console.log('CHANGE USER: ', user)
                                const cloneWorker = { ...copyObject(JobWorkerObj), ...user }
                                console.log("cloneWorker->onSelectUser", cloneWorker)
                                onChangeWorker(cloneWorker)
                                // console.log('cloneWorker ' + index, cloneWorker)
                            }}
                        />
                        <span style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                            <span>
                                <Form.Label>Phone</Form.Label>
                                <InputPhone
                                    disabled
                                    className="input-material"
                                    defaultValue={`${workerDirty.phone}`}
                                    value={`${workerDirty.phone}`}
                                    onChangeValue={val => { updateWorker('phone', val) }} />

                            </span>
                            <span>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    className='input-material'
                                    disabled
                                    value={`${workerDirty.email}`}
                                    onChange={(event: any) => { updateWorker('email', event.target.value) }} />
                            </span>
                        </span>
                    </span>
                </div>
                <div>
                    {worker.id != 0 && <div className="mt-2 mb-2">

                        <div key='custom-inline-checkbox'>
                            <Form.Check
                                inline
                                // custom
                                className='mt-2'
                                id={`${"custom-inline-"}${worker.noShow}-${index}-${checkBoxUniqueId}`}
                                checked={worker.noShow && worker.noShow == true ? true : false}
                                type="checkbox"
                                onChange={(event) => {
                                    updateWorker("noShow", !worker.noShow)
                                }}
                                label={<h5>No-show</h5>}
                            />
                        </div>
                    </div>}
                    {job.jobStatus != 'completed' && <CrewPermissions worker={workerDirty} updateWorker={updateWorker} index={index} />}
                    <Feedback
                        updateWorker={updateWorker}
                        worker={workerDirty} />
                    {renderDamages()}
                    {renderInfractions()}
                    {/* <Invoice

                        jobDuration={jobDuration}
                        hourlyRate={hourlyRate}
                        isLaborFlat={isLaborFlat}
                        invoice={workerDirty.invoice}
                        onChangeInvoice={(lineItems) => {
                            let workerClone = copyObject(workerDirty)
                            workerClone.invoice = lineItems
                            workerClone.isDirty = true
                            setWorkerDirty(workerClone)
                            updateCrew(index, workerClone)
                            console.log("workerClone", workerClone)
                        }}
                        updateWorker={updateWorker} /> */}
                </div>
            </div>

        )
    }



    const getDisplayName = (worker: JobWorkerT) => {
        if (isManager) {
            return `${worker.firstName} ${worker.lastName}`
        } else {
            return getInitialsLastName(worker.firstName, worker.lastName)
        }
    }

    const clientRenderWorker = (): JSX.Element => {

        return (
            <>
                <div style={{ display: 'grid', gridTemplateColumns: 'minmax(100px, 120px) 1fr' }}>
                    <span>
                        <Image src={(worker.profilePic == null || worker.profilePic == '') ? images.noProfilePic : worker.profilePic} height={100} width={100} />
                    </span>
                    <span>
                        <p style={{ fontSize: '2em' }}>
                            {`${workerDirty.firstName != '' || workerDirty.lastName != '' ? `${worker.firstName} ${worker.lastName.charAt(0)}.` : ''}`}
                        </p>
                        <Ratings
                            changeRating={(rating: number): void => {
                                updateWorker('rating', rating)
                            }}
                            rating={worker.rating && isNumber(worker.rating) ? worker.rating : 2.5}
                            widgetDimensions='30px'
                            widgetHoverColors='#f26000'
                            widgetRatedColors='#fed8b1'>
                            <Ratings.Widget />
                            <Ratings.Widget />
                            <Ratings.Widget />
                            <Ratings.Widget />
                            <Ratings.Widget />
                        </Ratings>
                    </span>
                </div>
                <div>
                    <Form.Label>Notes</Form.Label>
                    <Form.Control
                        as='textarea'
                        className='input-material'
                        rows={2}
                        value={`${worker.notes ? worker.notes : ''}`}
                        onChange={(e: any) => {
                            updateWorker('notes', e.target.value)
                        }}
                    />
                </div>
            </>
        )
    }



    const removeDamage = (damageIndex: number): void => {
        let workerClone = copyObject(workerDirty)
        let lineItems = copyObject(workerClone.damages)
        const filteredItems = lineItems.slice(0, damageIndex).concat(lineItems.slice(damageIndex + 1, lineItems.length))
        if (filteredItems.length <= 0) {
            filteredItems.push(DamageObj)
        }
        workerClone.damages = copyObject(filteredItems)
        setWorkerDirty(workerClone)
        updateCrew(index, workerClone)
    }

    const removeInfraction = (infractionIndex: number): void => {
        let workerClone = copyObject(workerDirty)
        let lineItems = copyObject(workerClone.infractions)
        const filteredItems = lineItems.slice(0, infractionIndex).concat(lineItems.slice(infractionIndex + 1, lineItems.length))
        if (filteredItems.length <= 0) {
            filteredItems.push(InfractionObj)
        }
        workerClone.infractions = copyObject(filteredItems)
        setWorkerDirty(workerClone)
        // workerClone.infractions.splice(infractionIndex, 1)
        updateCrew(index, workerClone)
    }




    const updateInfraction = (infractionIndex: number, newInfraction: InfractionT): void => {
        let infractions = copyObject(worker.infractions)
        infractions[infractionIndex] = newInfraction;
        updateWorker("infractions", infractions)
    }


    const renderDamages = (): JSX.Element => {
        return (
            <div>
                <h5>Damages</h5>
                {worker.damages.map((damage: DamageT, damageIndex: number) => {
                    return <Damage
                        key={damageIndex}
                        damage={copyObject(DamageObj)}
                        index={damageIndex}
                        removeDamage={removeDamage} />
                })}
                <Button
                    onClick={(): void => addDamage()}
                    variant='light'>
                    Add Damage
                </Button>
            </div>
        )
    }

    const renderInfractions = (): JSX.Element => {
        return (
            <div>
                <h5>Infractions</h5>
                {worker.infractions.map((infraction: InfractionT, infractionIndex: number) => {
                    return <Infraction
                        key={infractionIndex}
                        index={infractionIndex}
                        infraction={infraction}
                        removeInfraction={removeInfraction}
                        updateInfraction={updateInfraction} />
                })}
                <Button
                    onClick={(): void => addInfraction()}
                    variant='light'>
                    Add Infraction
                </Button>
            </div>
        )
    }

    /**
     *
     * @param key
     * @param value
     */
    const updateWorker = (key: string, value: any): void => {
        let workerClone = copyObject(workerDirty)
        console.log("workerClone", workerClone)
        if (!_.isEqual(workerClone[key], value) || !_.has(workerClone, key)) {
            workerClone[key] = value
            console.log("workerClone->key", key)
            console.log("workerClone->workerClone", workerClone)
            setWorkerDirty(workerClone)
            updateCrew(index, workerClone)
        }
    }


    if (!isReady) {
        return null
    }

    return isManager ? adminManagerRenderWorker() : (isClient ? clientRenderWorker() : null)
}

export default Worker
